import { FC } from 'react'
import { Counter } from '../counter'

export const FormattedDuration: FC<{ value: number }> = ({ value }) => {
  const minutes = Math.floor(value / 60)
  const seconds = Math.round(value % 60)

  return (
    <>
      <Counter value={minutes.toString().padStart(2, '0')} />
      :
      <Counter value={seconds.toString().padStart(2, '0')} />
    </>
  )
}
